// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { MintingClaimAnimationDetailsGlb } from '../models/MintingClaimAnimationDetailsGlb';
import { MintingClaimAnimationDetailsHtml } from '../models/MintingClaimAnimationDetailsHtml';
import { MintingClaimAnimationDetailsVideo } from '../models/MintingClaimAnimationDetailsVideo';
import { HttpFile } from '../http/http';

/**
 * @type MintingClaimAnimationDetails
 * Type
 * @export
 */
export type MintingClaimAnimationDetails = MintingClaimAnimationDetailsGlb | MintingClaimAnimationDetailsHtml | MintingClaimAnimationDetailsVideo;

/**
* @type MintingClaimAnimationDetailsClass
* @export
*/
export class MintingClaimAnimationDetailsClass {
    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;
}


